import { axios } from '@/common/api.service.js'

console.log('HERE SpellsJS')
//-----------
// set state
//-----------
const state = () => ({
  spells: [],
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})
//---------
// getters
//---------
const getters = {
  //------------
  // get spells
  //------------
  getSpells(state) {
    return state.spells
  },
  //------------------
  // get spell by name
  //------------------
  getSpellByName: (state) => (name) => {
    let spell = state.spells.find((a) => a.name == name)
    try {
      return spell
    } catch {
      return null
    }
  },
  //-----------------
  // get spell by id
  //-----------------
  getSpellById: (state) => (id) => {
    let spell = state.spells.find((a) => a.id == id)
    try {
      return spell
    } catch {
      return null
    }
  },
  // //---------------------
  // // get character spells
  // //---------------------
  // getCharacterSpells(state) {
  //   return state.character_spells
  // },
  // //--------------------------
  // // get spell characteristics
  // //--------------------------
  // getSpellCharacteristics: (state) => (id) => {
  //   let spell = state.spells.find((a) => a.id == id)
  //   if (!spell) {
  //     spell = state.character_spells.find((a) => a.id == id)
  //   }
  //   try {
  //     return spell.characteristics
  //   } catch {
  //     return null
  //   }
  // },
  // //---------------------
  // // get characteristics
  // //---------------------
  // getCharacteristics(state) {
  //   return state.characteristics
  // },
  //-------------
  // get headers
  //-------------
  getHeaders(state) {
    return state.headers
  },
}
//---------
// actions
//---------
const actions = {
  //===============================================================
  // load static spells
  //-------------------
  async loadStaticSpells({ commit, state }, forceReload = false) {
    if (!forceReload && Array.isArray(state.spells) && state.spells.length > 0) {
      return
    }
    // console.log("-----------------------")
    // console.log("JS loadStaticSpells..")
    const endpoint = 'api/v1/spells/?limit=1000'
    const headers = state.headers
    await axios
      .get(endpoint, {
        headers: headers,
        mode: 'same-origin',
      })
      //--------------
      // where api ok
      //--------------
      .then((response) => {
        commit('setSpells', response.data.results)
      })
      //-----------------
      // where api error
      //-----------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
  },
  //===============================================================
  // edit spell (add/change)
  //------------------------
  editSpell({ state }, parm) {
    // console.log("---------------------")
    // console.log("IN editSpell....")

    return new Promise((resolve, reject) => {
      const headers = state.headers
      axios({
        method: parm.api_request.method,
        url: parm.api_request.endpoint,
        headers: headers,
        data: parm.payload,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then((response) => {
          resolve(response)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((error) => {
          reject(error)
        })
    })
  },
  //===============================================================
  // delete spell
  //-------------
  deleteSpell({ state }, request) {
    //   console.log("----------------")
    // console.log("IN deleteSpell...")
    return new Promise((resolve, reject) => {
      const headers = state.headers
      axios({
        method: request.method,
        url: request.endpoint,
        headers: headers,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then((response) => {
          resolve(response)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((error) => {
          reject(error)
        })
    })
  },
}
//===============================================================
// mutations
//-----------
const mutations = {
  setSpells(state, payload) {
    state.spells = payload
  },
}
//===============================================================
// export
//--------
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
